
import i18n from 'i18next';
import { useEffect } from 'react';
import { useData } from '@hooks/useData';
import { LANGUAGES, Language } from '@constants';
import { loadFromLocalStorage, saveToLocalStorage } from '@utils/storage';

export const useInitLanguage = () => {

    const { setLanguage } = useData();

    useEffect(() => {
       let storedLanguage = loadFromLocalStorage('language') as Language | null;

        if (!storedLanguage) {
            const browserLanguageCode = navigator.language.slice(0, 2);
            const language = LANGUAGES.find(item => item.code === browserLanguageCode) || LANGUAGES[0];
            storedLanguage = language.code;
            saveToLocalStorage('language', storedLanguage, 120000);
        }
        setLanguage(storedLanguage);
        i18n.changeLanguage(storedLanguage);
    }, []);
}